// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__Oucd9","loaded":"Avatar_loaded__w-xp5","initial":"Avatar_initial__vUar8"};